<template>
  <div class="index-module_articleWrap_2Zphx">
      <div class="zhemo">什么才是真正的价值投资</div>
   
    <div class="index-module_textWrap_3ygOc">
      <p>
        <span class="bjh-p"
          >价值投资愈发成为市场关注的热点之一。但是市场上真正的价值投资者其实并没有想象中那么多。那么，如何区分真正的价值投资者和市场上其他的投资者呢？</span
        >
      </p>
      <!--20--><!--21--><!--22--><!--23--><!--24--><!--25-->
    </div>
    <div class="index-module_textWrap_3ygOc">
      <p>
        <span class="bjh-p"
          >依靠技术分析的投资者很显然不能被称为价值投资者。这类投资者不针对具体公司进行基础分析，不关心公司的报表、所在行业竞争格局、产品市场的特征。他们也不关注投资对象的经济价值，而是将主要精力集中于交易数据，包括证券的价格波动及交易量变化。技术投资者认为有关波动性的历史数据反映了证券在不同时间的供求关系，通过研究图形可以预测价格未来的运动趋势。</span
        >
      </p>
      <!--26--><!--27--><!--28--><!--29--><!--30--><!--31-->
    </div>
    <div class="index-module_textWrap_3ygOc">
      <p>
        <span class="bjh-p"
          >剩下的投资者在投资中都很关心投资标的的实际情况，但并不是所有人都可以被称为价值投资者。剩下的投资者大体上可以分为两类：一类主要关心宏观问题；另一类主要关心具体证券的微观状况。关心宏观的投资者关心影响证券的各种宏观经济因素，例如通货膨胀率、利率、汇率、失业率等等。他们通过宏观信息预测经济走势，并以判断哪些板块及行业最有可能受到经济走势的影响。这也是我们常说的“自上而下”的研究方法。</span
        >
      </p>
      <!--32--><!--33--><!--34--><!--35--><!--36--><!--37-->
    </div>
    <div class="index-module_textWrap_3ygOc">
      <p>
        <span class="bjh-p"
          >那么微观教旨主义者，即分析公司的经济基础因素并对证券逐一考察的投资者中，是否都是价值投资者吗？并非如此。有一类投资者，他们研究标的的历史价格情况，观察期价格如何随着一些微观经济因素变化。这些因素包括营收、行业背景、新产品引进、技术改进、厂房及设备投资等等。如果发现他们对未来收益及其他重要变量的估计值超出市场预期，就会购入相应的股票。</span
        >
      </p>
      <!--38--><!--39--><!--40--><!--41--><!--42--><!--43-->
    </div>
    <div class="index-module_textWrap_3ygOc">
      <p>
        <span class="bjh-p"
          >尽管这样的方法和价值投资十分相似，但是仍不能被称为价值投资方法。其与价值投资的区别主要在两个方面。一方面，这种方法重视对价格的先期预测，而非着眼于基础资产的价值。这样的分析方法可以同等地应用于估值10倍、20倍或50倍的股票。但是价值投资者不会将这些情形一概而论。另一方面，这种方法没有考虑安全边际，从而保护投资免受“市场先生”情绪变化的损害。</span
        >
      </p>
      <!--44--><!--45--><!--46--><!--47--><!--48--><!--49-->
    </div>
    <div class="index-module_textWrap_3ygOc">
      <p>
        <span class="bjh-p"
          >让我们将目光重新聚焦于价值投资。价值投资的核心方法很简单，价值投资者先评估某一金融资产的内在价值，并将其与市场提供的现价相比。如果价格低于价值，并且能够提供充足的安全边际，那么久可以买入该标的并进行持有。具体到操作层面上，不同投资者的方法可能有所区别，例如运用不同的指标和方法判断资产的内在价值等。但其核心思想一直没有发生变化。</span
        >
      </p>
      <!--50--><!--51--><!--52--><!--53--><!--54--><!--55-->
    </div>
    <!--13--><!--56--><!--57-->
   <p class="free">（来源：东方红资管）</p>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>